import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const BulkEnrollScheduledAnalysisReason = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.BULK_ENROLL_SCHEDULED"
  });
};
export default BulkEnrollScheduledAnalysisReason;